// extracted by mini-css-extract-plugin
export default {"cls1":"PaperNewsStory-cls1___ab1242d7294fe37a5df","cls2":"PaperNewsStory-cls2__b1a73e8b59f2dbcaee51 PaperNewsStory-cls1___ab1242d7294fe37a5df"};